export {NewsPagination} from './pagination'
